'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _promise = require('babel-runtime/core-js/promise');

var _promise2 = _interopRequireDefault(_promise);

var _dec, _class; /**
                   * Created by zfc on 2017/7/15.
                   */

// import * as authActions from 'redux/modules/auth';
// import {connect} from 'react-redux';
// import { push } from 'react-router-redux';


var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _components = require('components');

var _background = require('redux/modules/background');

var _reduxAsyncConnect = require('redux-async-connect');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ExperienceShopRegisterNew = (_dec = (0, _reduxAsyncConnect.asyncConnect)([{
  deferred: false,
  promise: function promise(_ref) {
    var dispatch = _ref.store.dispatch;

    var promises = [];
    promises.push(dispatch((0, _background.changeHeaderText)('体验店注册')));
    return _promise2.default.all(promises);
  }
}]), _dec(_class = function (_Component) {
  (0, _inherits3.default)(ExperienceShopRegisterNew, _Component);

  function ExperienceShopRegisterNew() {
    (0, _classCallCheck3.default)(this, ExperienceShopRegisterNew);
    return (0, _possibleConstructorReturn3.default)(this, (0, _getPrototypeOf2.default)(ExperienceShopRegisterNew).call(this));
  }

  (0, _createClass3.default)(ExperienceShopRegisterNew, [{
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(_components.ExperienceShopRegisterComponent, null),
        _react2.default.createElement('div', { className: 'clear' })
      );
    }
  }]);
  return ExperienceShopRegisterNew;
}(_react.Component)) || _class);
exports.default = ExperienceShopRegisterNew;
module.exports = exports['default'];


/*****************
 ** WEBPACK FOOTER
 ** ./src/containers/ExperienceShopRegisterNew/ExperienceShopRegisterNew.js
 ** module id = 1481
 ** module chunks = 0
 **/